export default {
  loading: state => state.loading,
  getProfileList: state => state.profileList,
  getProfileTypeList: state => state.profileTypeList,
  getCurrentStep: state => state.currentStep,
  getCreateTypeId: state => state.createTypeId,
  getEditProfileId: state => state.editProfileId,
  getProfileProps: state => state.profileProps,
  isEmpty: (state) => {
    if (state.currentProfile.VALUES) {
      for (let prop of state.currentProfile.VALUES) {
        if (prop.VALUE) {
          return false
        }
      }
    }
    return true
  },
  currentProfile: state => state.currentProfile,
  currentPersonType: state => {
    for (let personType of state.personTypes) {
      if (parseInt(personType.ID) === parseInt(state.currentPersonTypeId)) {
        return personType
      }
    }
  },
  personTypes: state => state.personTypes,
  currentPersonTypeId: state => state.currentPersonTypeId,
  error: state => state.error,
  legalProfiles: state => state.profileList.filter(e => e.typeId === 2),
  getProfileName: state => state.profileName
}



// WEBPACK FOOTER //
// ./src/components/store/modules/profile/getters.js